import fetchModel from "../../mixin/store/api/fetchModel";
import pushModel from "../../mixin/store/api/pushModel";
import changeModel from "../../mixin/store/api/changeModel";
import fetchModels from "@/mixin/store/api/fetchModels";
import axios from "@/plugins/axios";

export default {
    actions: {
        fetchProductPurchase(context, id) {
            return fetchModel(context, 'product_purchases', id, 'updateProductPurchaseDetails');
        },
        fetchProductPurchasesLastRecordLB(context) {
            return axios.get('product_purchases/all')
                .then((response) => {
                    console.log(response)
                    let data = response.data

                    context.commit('updateProductPurchasesLB', data)

                })
                .catch((err) => {
                    console.log(err)
                })
        },
        fetchTodayPurchasesTotalAmount(context) {
            return fetchModel(context, 'product_purchases/today_purchases', null, 'updateTodayTotalAmount');
        },
        fetchProductPurchaseHistory(context, search) {
            return fetchModels(
                context,
                'product_purchases?',
                search.page + '&order[id]=desc&product.id=' + search.productId + '&isCancelled=false',
                'updateProductPurchaseHistory');
        },
        fetchPurchases(context, search) {
            return fetchModels(context, 'purchases/all', search.page,'updatePurchases');
        },
        pushProductPurchase(context, data) {
            data.warehouse = '/api/warehouses/' + data.warehouseId
            data.product = '/api/products/' + data.productId
            data.currency = '/api/currencies/' + data.currencyId
            data.supplier = '/api/suppliers/' + data.supplierId

            if (data.pricePerUnit) {
                data.pricePerUnit = data.pricePerUnit.replace(',', '.')
            }

            if (typeof data.amount === "string") {
                data.amount = parseInt(data.amount)
            }

            if (data.alertAmount === 0) {
                data.alertAmount = null
                data.additionalUnitOfMeasure = null
            }

            return pushModel(context, 'product_purchases', data)
        },
        pushProductsPurchase(context, data) {
            return pushModel(context, 'purchases/make_purchase', data)
        },
        pushProductPurchaseMakeDeleted(context, selectedProductIds) {
            return pushModel(context, 'product_purchases/make_deleted', {itemDtos: selectedProductIds})
        },
        pushProductPurchaseMakePayed(context, id) {
            return changeModel(context, 'product_purchases/' + id + '/make_payed', {})
        },
        pushPurchaseMakePayed(context, id) {
            return changeModel(context, 'purchases/' + id + '/make_payed', {})
        },
        pushProductPurchaseMakeUnPayed(context, id) {
            return changeModel(context, 'product_purchases/' + id + '/make_unpayed', {})
        },
        pushPurchaseMakeUnPayed(context, id) {
            return changeModel(context, 'purchases/' + id + '/make_unpayed', {})
        },
        setProductPurchaseDetails(context, data) {
            context.commit('updateProductPurchaseDetails', data)
        },
        setPurchaseDetails(context, data) {
            context.commit('updatePurchaseDetails', data)
        },
        fetchProductPurchaseSupplier(context, searchItem) {
            let url = '/product_purchases?page=' + searchItem.page + '&order[id]=desc&supplier.id=' + searchItem.supplierId + '&isCancelled=false';

            if (searchItem.after) {
                url = url + '&createdAt[strictly_after]=00:00:00' + searchItem.after
            }

            if (searchItem.isPayed !== null) {
                url = url + '&exists[transaction]=' + searchItem.isPayed
            }

            if (searchItem.startDate) {
                url = url + '&pagination=false&createdAt[before]=' + searchItem.endDate
            }

            if (searchItem.before) {
                url = url + '&createdAt[strictly_before]=23:59:59' + searchItem.before
            }

            if (searchItem.endDate) {
                url = url + '&pagination=false&createdAt[after]=' + searchItem.startDate
            }

            if (searchItem.totalPriceMin) {
                url = url + '&totalPrice[gte]=' + searchItem.totalPriceMin
            }

            if (searchItem.totalPriceMax) {
                url = url + '&totalPrice[lte]=' + searchItem.totalPriceMax
            }

            return new Promise((resolve, reject) => {
                axios.get(url)
                    .then((response) => {
                        let data = {
                            models: response.data['hydra:member'],
                            totalItems: response.data['hydra:totalItems']
                        }
                        context.commit('updateProductPurchases', data)
                        resolve(response.data)
                    })
                    .catch(() => {
                        reject()
                    })

            })
        },
        searchProductPurchase(context, searchItem) {
            let url = "product_purchases?page=" + searchItem.page;
            let isSearch = false;

            if (searchItem.productName) {
                url = url + '&product.name=' + searchItem.productName
                isSearch = true
            }

            if (searchItem.productId) {
                url = 'product_purchases?itemsPerPage=1&order[id]=desc&product.id=' + searchItem.productId
                isSearch = true
            }

            if (searchItem.purchaseId) {
                url = 'product_purchases?itemsPerPage=1&order[id]=desc&purchase.id=' + searchItem.purchaseId
                isSearch = true
            }

            if (searchItem.personGivenName) {
                url = url + '&supplier.person.givenName=' + searchItem.personGivenName
                isSearch = true
            }

            if (searchItem.personFamilyName) {
                url = url + '&supplier.person.familyName=' + searchItem.personFamilyName
                isSearch = true
            }

            if (searchItem.personAdditionalName) {
                url = url + '&supplier.person.additionalName=' + searchItem.personAdditionalName
                isSearch = true
            }

            if (searchItem.companyName) {
                url = url + '&supplier.supplierCompany.name=' + searchItem.companyName
                isSearch = true
            }

            if (searchItem.minAmount) {
                url = url + '&amount[gte]=' + searchItem.minAmount
                isSearch = true
            }

            if (searchItem.maxAmount) {
                url = url + '&amount[lte]=' + searchItem.maxAmount
                isSearch = true
            }

            if (searchItem.minPrice) {
                url = url + '&totalPrice[gte]=' + searchItem.minPrice
                isSearch = true
            }

            if (searchItem.maxPrice) {
                url = url + '&totalPrice[lte]=' + searchItem.maxPrice
                isSearch = true
            }

            if (searchItem.isPayed !== null) {
                url = url + '&exists[transaction]=' + searchItem.isPayed
                isSearch = true
            }

            if (searchItem.after) {
                url = url + '&createdAt[strictly_after]=00:00:00' + searchItem.after
                isSearch = true
            }

            if (searchItem.startDate) {
                url = url + '&pagination=false&createdAt[before]=' + searchItem.endDate
                isSearch = true
            }

            if (searchItem.endDate) {
                url = url + '&pagination=false&createdAt[after]=' + searchItem.startDate
                isSearch = true
            }

            if (searchItem.before) {
                url = url + '&createdAt[strictly_before]=23:59:59' + searchItem.before
                isSearch = true
            }

            if (!isSearch) {
                url += "&order[id]=desc"
            }

            return axios.get(url)
                .then((response) => {
                    console.log(response)
                    let data = {
                        models: response.data['hydra:member'],
                        totalItems: response.data['hydra:totalItems']
                    }

                    context.commit('updateProductPurchases', data)

                })
                .catch((err) => {
                    console.log(err)
                })
        },
        pushProductPurchaseRePayed(context, data) {
            return changeModel(context, 'product_purchases/' + data.id, data)
        },
        pushPurchaseRePayed(context, data) {
            return pushModel(context, 'purchases/pay_debt', data)
        },
        setProductPurchaseCancelled(context, id) {
            return changeModel(context, 'product_purchases/' + id + '/cancel', {})
        },
        setPurchaseCancelled(context, id) {
            return changeModel(context, 'purchases/' + id + '/cancel', {})
        },
        searchPurchase(context, searchItem) {
            let url = "purchases/all?page=" + searchItem.page;
            let isSearch = false;

            if (searchItem.personGivenName) {
                url = url + '&supplierName=' + searchItem.personGivenName
                isSearch = true
            }

            if (searchItem.personFamilyName) {
                url = url + '&supplierFName=' + searchItem.personFamilyName
                isSearch = true
            }

            if (searchItem.companyName) {
                url = url + '&supplierCompanyName=' + searchItem.companyName
                isSearch = true
            }

            if (searchItem.minPrice) {
                url = url + '&totalPriceGTE=' + searchItem.minPrice
                isSearch = true
            }

            if (searchItem.maxPrice) {
                url = url + '&totalPriceLTE=' + searchItem.maxPrice
                isSearch = true
            }

            if (searchItem.isPayed !== null) {
                url = url + '&isPayed=' + searchItem.isPayed
                isSearch = true
            }

            if (searchItem.after) {
                url = url + '&createdAfter=00:00:00' + searchItem.after
                isSearch = true
            }

            if (searchItem.before) {
                url = url + '&createdBefore=23:59:00' + searchItem.before
                isSearch = true
            }

            if (!isSearch) {
                url += "&order[id]=desc"
            }

            return axios.get(url)
                .then((response) => {
                    let data = {
                        models: response.data['hydra:member'],
                        totalItems: response.data['hydra:totalItems']
                    }

                    context.commit('updatePurchases', data)

                })
                .catch((err) => {
                    console.log(err)
                })
        },
    },
    mutations: {
        updateProductPurchases(state, data) {
            state.productPurchases = data
        },
        updateProductPurchaseDetails(state, data) {
            state.productPurchaseDetails = data
        },
        updateProductPurchasesLB(state, data) {
            state.productPurchases.models = data
        },
        updateTodayTotalAmount(state, data) {
            state.todayTotalAmount = data
        },
        updatePurchases(state, data) {
            function sort (purchases, prop) {
                return purchases.sort(function (a, b) {
                    if (a[prop] > b[prop]) return - 1;
                })
            }
            let purchases = sort(data.models[0], 'createdAt')
            state.purchases = data
            state.purchases.models[0] = purchases
        },
        updateProductPurchaseHistory(state, data) {
            state.purchasesHistory = data
        },
        updatePurchaseDetails(state, data) {
            state.purchaseDetails = data
        }
    },
    state: {
        productPurchases: {
            models: [],
            totalItems: 0,
        },
        productPurchaseDetails: {
            id: null,
            product: {
                name: null,
            },
            amount: null,
            supplier: null,
            pricePerUnit: null,
            totalPrice: null,
            transaction: null,
            isCancelled: false
        },
        todayTotalAmount: {},
        purchases: {
            models: [],
            totalItems: 0,
        },
        purchasesHistory: {
            models: [],
            totalItems: 0,
        },
        purchaseDetails: {

        }
    },
    getters: {
        getProductPurchases(state) {
            return state.productPurchases.models
        },
        getProductPurchasesTotalCount(state) {
            return state.productPurchases.totalItems
        },
        getProductPurchaseDetails(state) {
            return state.productPurchaseDetails
        },
        getTodayPurchasesTotalAmount(state) {
            return state.todayTotalAmount
        },
        getPurchases(state) {
            return state.purchases.models
        },
        getProductPurchaseHistory(state) {
            return state.purchasesHistory.models
        },
        getProductPurchaseHistoryTotalCount(state) {
            return state.purchasesHistory.totalItems
        },
        getPurchasesTotalCount(state) {
            return state.purchases.models[1]
        }
    },
}
